import React, { useRef } from "react";
import Redirect from "../Redirect/Redirect";

const AuthenticationCallBack: React.FC<any> = (
  props: React.PropsWithChildren<any>
) => {
  const returnUrl = useRef<string>();

  console.log(returnUrl.current);
  if  (!returnUrl.current) {
    returnUrl.current = sessionStorage.getItem("returnlUrl") ?? "/";
    sessionStorage.removeItem("returnlUrl");
  }

  

  return <Redirect to={returnUrl.current} />;
};
export default AuthenticationCallBack;
